<div class="relative">
  <button class="absolute top-0 right-0 m-20 icon-button is-primary is-inverted" attr.aria-label="Close"
    [mat-dialog-close] type="button">
    <i class="material-icons">close</i>
  </button>
</div>
<section class="overflow-auto">
  <app-submit-application (closed)="onCloseCallback($event)"></app-submit-application>
</section>